export class MediaDevices {

    constructor(callback){
        this.callback = callback;
    };

    async getAudio(){
        try{
            return await navigator.mediaDevices.getUserMedia({audio:true});
        } catch (error) {
            this.callback();
        } 
    };
};